import React, { Component } from "react";
import { AppCard, createTabHeaderTemplate, PageLayout } from "../../components/ui";

import PendingKycSubmissions from "./PendingKycSubmissions";
import UnderReviewKycSubmissions from "./UnderReviewKycSubmissions";
import ClosedKycSubmissions from "./ClosedKycSubmissions";
import { TabPanel, TabView } from "primereact/tabview";
import { isKYCApproveAllowed, isKYCAssessAllowed } from "../../authGuard";
import { Button } from "primereact/button";
import RiskSettings from "./RiskSettings";
import { ShieldCheck } from "lucide-react";

interface KycSubmissionState {
    activeTabIndex: number;
    viewKycSubmissionModal: boolean;
    viewRiskSettingsModal: boolean;
}

export default class KycSubmissionComponent extends Component<Record<string, never>, KycSubmissionState> {
    tabNames: string[] = ["Pending KYC Submissions", "KYC Submissions Under Review", "Closed KYC Submissions"];
    constructor(props: Record<string, never> | Readonly<Record<string, never>>) {
        super(props);

        this.state = {
            activeTabIndex: 0,
            viewKycSubmissionModal: false,
            viewRiskSettingsModal: false,
        };
    }

    toggleRiskSettingsModalView = async () => {
        this.setState({ viewRiskSettingsModal: false });
    };

    render() {
        return (
            <PageLayout heading="KYC" icon={ShieldCheck} className="!px-0">
                                {this.state.viewRiskSettingsModal && <RiskSettings onHide={this.toggleRiskSettingsModalView} />}
                                {/* {this.state.viewRiskSettingsModal && <LookupItemsForm onHide={this.toggleRiskSettingsModalView} />} */}
                                <AppCard className="mb-3">
                                    <AppCard.Header
                                        title="KYC Submissions"
                                        actions={
                                            isKYCApproveAllowed() ? (
                                                <Button
                                                    label="Risk Settings"
                                                    text
                                                    rounded
                                                    onClick={() => this.setState({ viewRiskSettingsModal: true })}
                                                />
                                            ) : undefined
                                        }
                                    />
                                    <AppCard.Body className="!p-0">
                                        <TabView
                                            activeIndex={this.state.activeTabIndex}
                                            onTabChange={(e) => {
                                                this.setState({ activeTabIndex: e.index });
                                            }}
                                        >
                                            <TabPanel
                                                pt={{ content: { className: "pt-0 px-5 pb-5" } }}
                                                header="Completed KYC Submissions"
                                                headerTemplate={createTabHeaderTemplate(this.state.activeTabIndex)}
                                            >
                                                <ClosedKycSubmissions />
                                            </TabPanel>
                                            {isKYCAssessAllowed() && (
                                                <TabPanel
                                                    pt={{ content: { className: "pt-0 px-5 pb-5" } }}
                                                    header="Pending KYC Submissions"
                                                    headerTemplate={createTabHeaderTemplate(this.state.activeTabIndex)}
                                                >
                                                    <PendingKycSubmissions />
                                                </TabPanel>
                                            )}
                                            {isKYCAssessAllowed() && (
                                                <TabPanel
                                                    pt={{ content: { className: "pt-0 px-5 pb-5" } }}
                                                    header="KYC Submissions Under Review"
                                                    headerTemplate={createTabHeaderTemplate(this.state.activeTabIndex)}
                                                >
                                                    <UnderReviewKycSubmissions showKycSubmissionsStatus={"UnderReview"} />
                                                </TabPanel>
                                            )}
                                            {isKYCApproveAllowed() && (
                                                <TabPanel
                                                    pt={{ content: { className: "pt-0 px-5 pb-5" } }}
                                                    header="KYC Submissions Awaiting Approval"
                                                    headerTemplate={createTabHeaderTemplate(this.state.activeTabIndex)}
                                                >
                                                    <UnderReviewKycSubmissions showKycSubmissionsStatus={"AwaitingApproval"} />
                                                </TabPanel>
                                            )}
                                        </TabView>
                                    </AppCard.Body>
                                </AppCard>
            </PageLayout>
        );
    }
}
